export const getRandomProfileImage = () => {
  const urls = [
    'https://s3.amazonaws.com/crystal-cdn/images/Elon.jpg',
    'https://s3.amazonaws.com/crystal-cdn/images/Bill.jpg',
    'https://s3.amazonaws.com/crystal-cdn/images/Bill.jpg',
    'https://profile-photos.crystalknows.com/f56509ff-b14c-4ee5-85af-cbc9b27d547f/1542833866/thumb_Austin.png',
    'https://profile-photos.crystalknows.com/5ca98ba4-f4fe-4264-a7fe-e53a5cdf6ac7/1540481668/thumb_cropped.png',
    'https://profile-photos.crystalknows.com/a200e06d-0c20-4a86-aca2-4514a1cfdcd5/1541000045/thumb_drew_table.png',
    'https://profile-photos.crystalknows.com/670ce91d-a0f3-49d7-babc-13d11345881f/1540996905/thumb_cake.png',
    'https://profile-photos.crystalknows.com/7a497104-b514-41db-b5a8-a1a78c68fdc1/1541176597/thumb_prof_pic.png',
    'https://cdn.crystalknows.com/uploads/320467/58cb8b7d4c06a118f63aa4feb6a80e00',
    'https://profile-photos.crystalknows.com/805e5317cc690e4c1abed63163353169/ed89a5c5cd9bc8a21f615dd426d1b8e9',
    'https://profile-photos.crystalknows.com/f732d8f8-7240-440b-9bb0-57d113a285a3/1522345728/thumb_Tahiti_headshot.png',
    'https://d2ojpxxtu63wzl.cloudfront.net/static/c1620a110ea4701675fa178fd9826efe_bb46d0ca93e66644fe4835186dc75b6fa30de9afb4ae2c0af6b719b56674e82d',
    'https://profile-photos.crystalknows.com/7bd84286-630e-4144-b4f5-bc74dfc47208/1531777948/thumb_headshot_skloot.png',
    'https://profile-photos.crystalknows.com/38c22347-3608-4166-b448-f83e061c75b0/1529356598/thumb_4S1A4739-01-01.png',
    'https://profile-photos.crystalknows.com/455569ac-3e1a-4246-b0ec-3b8d75f3d8c3/1519939672/thumb_new_gray_and_coral_cropped.png',
  ]

  return urls[Math.floor(Math.random() * urls.length)]
}
